import React from 'react'
import { useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai'

const Donation = () => {
  const [open, setOpen] = useState(false)

  return (
        <>
        {/* Floating Donate Button */}
        <button className="donate-btn" onClick={() => setOpen(true)}>
            Donate
        </button>

        {/* Popup Overlay */}
        {open && (
            <div className="donation-overlay" onClick={() => setOpen(false)}>
            <div className="donation-box" onClick={(e) => e.stopPropagation()}>
                
                {/* Close Icon */}
                <AiOutlineClose
                className="close-icon"
                onClick={() => setOpen(false)}
                />

                <h3>Support David’s Court</h3>
                <p>Your giving helps us spread the gospel and support our community.</p>

                <a
                href="https://buy.stripe.com/3cIcN4bDReNddFzgyQ0sU00"
                target="_blank"
                rel="noopener noreferrer"
                className="donate-link"
                >
                Click here to give
                </a>
            </div>
            </div>
        )}
    </>
  )
}

export default Donation